import { render, staticRenderFns } from "./_queryStudy.vue?vue&type=template&id=704d2e34&scoped=true"
import script from "./_queryStudy.vue?vue&type=script&lang=js"
export * from "./_queryStudy.vue?vue&type=script&lang=js"
import style0 from "./_queryStudy.vue?vue&type=style&index=0&id=704d2e34&prod&lang=scss&scoped=true"
import style1 from "./_queryStudy.vue?vue&type=style&index=1&id=704d2e34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704d2e34",
  null
  
)

export default component.exports